module.exports={render:function (){var _vm=this;
  return _vm._c('div', {
    class: ['movie-modal', {
      'is-loaded': _vm.isLoaded
    }, {
      'is-not-moving': !_vm.isMoving
    }]
  }, [_vm._c('video-player', {
    ref: "myPlayer",
    attrs: {
      "options": _vm.videoOptions
    },
    on: {
      "player-state-changed": _vm.playerStateChanged
    }
  }), _vm._v(" "), _vm._v(" "), _vm._c('clip-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": _vm.color
    }
  }), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    class: ['controls-panel second', {
      'is-movie': !_vm.isMovie
    }]
  }, [(this.movie && this.movie.slug) ? _vm._c('ul', {
    staticClass: "controls"
  }, [_vm._c('li', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-right",
      value: ('back to ' + this.movie.title_tmdb_original),
      expression: "'back to ' + this.movie.title_tmdb_original",
      modifiers: {
        "top-right": true
      }
    }],
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.disableTooltips()
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'movie',
        params: {
          slug: this.movie.slug
        }
      }
    }
  }, [_vm._c('img', {
    staticClass: "playing-movie-thumbnail",
    attrs: {
      "src": 'https://image.tmdb.org/t/p/w500' + (_vm.movie.backdrops ? _vm.movie.backdrops[0] : _vm.movie.poster)
    }
  }), _vm._v(" "), _vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 256 256",
      "height": "256px",
      "version": "1.1",
      "viewBox": "0 0 256 256",
      "width": "256px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M91.474,33.861l-89.6,89.6c-2.5,2.5-2.5,6.551,0,9.051l89.6,89.6c2.5,2.5,6.551,2.5,9.051,0s2.5-6.742,0-9.242L21.849,134  H249.6c3.535,0,6.4-2.466,6.4-6s-2.865-6-6.4-6H21.849l78.676-78.881c1.25-1.25,1.875-2.993,1.875-4.629s-0.625-3.326-1.875-4.576  C98.024,31.413,93.974,31.361,91.474,33.861z"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _vm._v(" "), (this.movie) ? _vm._c('div', {
    class: ['controls-panel main', {
      'is-playing': !_vm.isPlaying
    }, {
      'is-show': _vm.isMoving
    }]
  }, [_vm._c('ul', {
    staticClass: "controls"
  }, [(this.filter === '') ? _vm._c('li', {
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.closeMovie()
      }
    }
  }, [_vm._c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-left",
      value: ('back to list'),
      expression: "'back to list'",
      modifiers: {
        "top-left": true
      }
    }],
    staticClass: "tooltip-container"
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 256 256",
      "height": "256px",
      "version": "1.1",
      "viewBox": "0 0 256 256",
      "width": "256px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (this.filter !== '') ? _vm._c('li', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-left",
      value: ('back to list'),
      expression: "'back to list'",
      modifiers: {
        "top-left": true
      }
    }],
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.closeMovie()
      }
    }
  }, [_vm._c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-left",
      value: ('back to list'),
      expression: "'back to list'",
      modifiers: {
        "top-left": true
      }
    }],
    staticClass: "tooltip-container"
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: this.filter
        }
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 256 256",
      "height": "256px",
      "version": "1.1",
      "viewBox": "0 0 256 256",
      "width": "256px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (this.movie.title_tmdb) ? _vm._c('li', {
    class: ['infos-cta', {
      'menu-is-active': _vm.infosActive
    }],
    on: {
      "click": function($event) {
        _vm.toggleInfos()
      }
    }
  }, [_vm._c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ('infos'),
      expression: "'infos'",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "tooltip-container"
  }, [_vm._c('h3', [_vm._v("i")])])]) : _vm._e(), _vm._v(" "), (this.movie.title_tmdb && _vm.videoOptions.source.src) ? _vm._c('li', {
    class: ['download', {
      'menu-is-active': _vm.downloadActive
    }],
    on: {
      "click": function($event) {
        _vm.toggleDownload()
      }
    }
  }, [_vm._c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ('download'),
      expression: "'download'",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "tooltip-container"
  }, [_vm._c('svg', {
    attrs: {
      "height": "19px",
      "version": "1.1",
      "viewBox": "0 0 14 19",
      "width": "14px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('title'), _vm._c('desc'), _vm._c('defs'), _vm._c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1"
    }
  }, [_vm._c('g', {
    attrs: {
      "transform": "translate(-383.000000, -213.000000)"
    }
  }, [_vm._c('g', {
    attrs: {
      "id": "file-download",
      "transform": "translate(383.000000, 213.500000)"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M14,6 L10,6 L10,0 L4,0 L4,6 L0,6 L7,13 L14,6 L14,6 Z M0,15 L0,17 L14,17 L14,15 L0,15 L0,15 Z"
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (this.movie && this.movie.backdrops) ? _vm._c('li', {
    class: ['backdrops-cta', {
      'menu-is-active': _vm.mosaicActive
    }],
    on: {
      "click": function($event) {
        _vm.toggleMosaic()
      }
    }
  }, [_vm._c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ('gallery'),
      expression: "'gallery'",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "tooltip-container"
  }, [_vm._c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 965.199 965.199"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "512px",
      "height": "512px",
      "viewBox": "0 0 965.199 965.199",
      "xml:space": "preserve"
    }
  }, [_vm._c('g', [_vm._c('path', {
    attrs: {
      "d": "M263.85,30c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202.1c0,16.6,13.4,30,30,30h202.1c16.6,0,30-13.4,30-30V30   H263.85z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M613.55,30c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202.1c0,16.6,13.4,30,30,30h202c16.6,0,30-13.4,30-30V30z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M963.25,30c0-16.6-13.4-30-30-30h-202c-16.601,0-30,13.4-30,30v202.1c0,16.6,13.399,30,30,30h202.1c16.601,0,30-13.4,30-30   V30H963.25z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M263.85,381.6c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202c0,16.6,13.4,30,30,30h202.1c16.6,0,30-13.4,30-30v-202   H263.85z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M613.55,381.6c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202c0,16.6,13.4,30,30,30h202c16.6,0,30-13.4,30-30V381.6z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M963.25,381.6c0-16.6-13.4-30-30-30h-202c-16.601,0-30,13.4-30,30v202c0,16.6,13.399,30,30,30h202.1   c16.601,0,30-13.4,30-30v-202H963.25z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M233.85,703.1h-202c-16.6,0-30,13.4-30,30v202.1c0,16.602,13.4,30,30,30h202.1c16.6,0,30-13.398,30-30V733.1   C263.85,716.6,250.45,703.1,233.85,703.1z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M583.55,703.1h-202c-16.6,0-30,13.4-30,30v202.1c0,16.602,13.4,30,30,30h202c16.6,0,30-13.398,30-30V733.1   C613.55,716.6,600.149,703.1,583.55,703.1z",
      "fill": "#FFFFFF"
    }
  }), _vm._c('path', {
    attrs: {
      "d": "M933.25,703.1h-202c-16.601,0-30,13.4-30,30v202.1c0,16.602,13.399,30,30,30h202.1c16.601,0,30-13.398,30-30V733.1   C963.25,716.6,949.85,703.1,933.25,703.1z",
      "fill": "#FFFFFF"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (this.movie.title_tmdb) ? _vm._c('li', {
    class: ['title', {
      'hide-title': (_vm.infosActive || !_vm.titleActive)
    }]
  }, [_vm._c('h1', [_vm._v(_vm._s(this.movie.title_tmdb))])]) : _vm._e()]), _vm._v(" "), _vm._v(" "), _vm._c('span', {
    class: ['submenu-arrow infos-arrow', {
      'submenu-active': _vm.infosActive
    }]
  }), _vm._v(" "), _vm._c('div', {
    class: ['submenu infos', {
      'submenu-active': _vm.infosActive
    }]
  }, [_vm._c('h1', [_vm._v(_vm._s(this.movie.title_tmdb))]), _vm._v(" "), (this.movie.director) ? _vm._c('h3', [_vm._v(_vm._s(this.movie.director.join(" & ")) + ", " + _vm._s(this.movie.date))]) : _vm._e(), _vm._v(" "), (this.movie.title_tmdb_original !== this.movie.title_tmdb) ? _vm._c('div', [_vm._c('br'), _vm._v(" "), _vm._c('b', [_vm._v(_vm._s(this.movie.title_tmdb_original))]), _vm._v(" "), _vm._c('br'), _vm._v("\n      (original title)\n      ")]) : _vm._e(), _vm._v(" "), _vm._c('p', [_vm._v(_vm._s(this.movie.overview))]), _vm._v(" "), _vm._c('p', [_vm._v(_vm._s(this.movie.duration) + " minutes")]), _vm._v(" "), (this.movie.cast) ? _vm._c('p', [_vm._v("With " + _vm._s(this.movie.cast.join(", ")) + ".")]) : _vm._e(), _vm._v(" "), _vm._c('div', [(this.movie.genres) ? _vm._c('h4', _vm._l((this.movie.genres), function(genre) {
    return _vm._c('div', {
      staticClass: "movie-genre"
    }, [_vm._c('router-link', {
      attrs: {
        "to": {
          name: 'genre',
          params: {
            genre: genre
          }
        }
      }
    }, [_vm._c('span', {
      on: {
        "click": function($event) {
          _vm.updateFilterTag(genre)
        }
      }
    }, [_vm._v(_vm._s(genre))])]), _vm._v(" "), _vm._c('span', {
      staticClass: "movie-genre-spacer"
    }, [_vm._v("| ")])])
  })) : _vm._e(), _vm._v(" "), _vm._c('h4', [_vm._c('a', {
    attrs: {
      "href": 'https://archive.org/details/' + this.movie.id_archive,
      "target": "_blank",
      "title": "see the movie on archive.org - new tab"
    }
  }, [_vm._v("Internet Archive")]), _vm._v("\n          -\n          "), _vm._c('a', {
    attrs: {
      "href": 'https://www.themoviedb.org/movie/' + this.movie.id_tmdb,
      "target": "_blank",
      "title": "see the movie on themoviedb.org - new tab"
    }
  }, [_vm._v("TMDb")]), _vm._v("\n          -\n          "), (this.movie.id_imdb) ? _vm._c('a', {
    attrs: {
      "href": 'https://www.imdb.com/title/' + this.movie.id_imdb,
      "target": "_blank",
      "title": "see the movie on imdb.com - new tab"
    }
  }, [_vm._v("IMDb")]) : _vm._e()])])]), _vm._v(" "), _vm._v(" "), _vm._c('span', {
    class: ['submenu-arrow download-arrow', {
      'submenu-active': _vm.downloadActive
    }]
  }), _vm._v(" "), _vm._c('div', {
    class: ['submenu download', {
      'submenu-active': _vm.downloadActive
    }]
  }, [_vm._c('a', {
    attrs: {
      "href": _vm.videoOptions.source.src,
      "download": ""
    }
  }, [_vm._v("\n        click to direct download .mp4 file\n      ")])]), _vm._v(" "), _vm._v(" "), _vm._c('span', {
    class: ['submenu-arrow mosaic-arrow', {
      'submenu-active': _vm.mosaicActive
    }]
  }), _vm._v(" "), _vm._c('div', {
    class: ['submenu mosaic', {
      'submenu-active': _vm.mosaicActive
    }]
  }, _vm._l((_vm.movie.backdrops), function(backdrop, iBackdrop) {
    return _vm._c('img', {
      staticClass: "mosaic-thumbnail",
      attrs: {
        "src": 'https://image.tmdb.org/t/p/w342' + backdrop,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.openGallery(iBackdrop)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    class: ['gallery', {
      'gallery-active': _vm.galleryActive
    }]
  }, [_vm._c('div', {
    staticClass: "cross",
    on: {
      "click": function($event) {
        _vm.closeGallery()
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 256 256",
      "height": "256px",
      "id": "Layer_1",
      "version": "1.1",
      "viewBox": "0 0 256 256",
      "width": "256px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
    }
  })]), _vm._v(" ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "arrow left",
    on: {
      "click": function($event) {
        _vm.goRight()
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 32 32",
      "height": "32px",
      "version": "1.1",
      "viewBox": "0 0 32 32",
      "width": "32px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "clip-rule": "evenodd",
      "d": "M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "arrow-clickzone"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "arrow right",
    on: {
      "click": function($event) {
        _vm.goLeft()
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 32 32",
      "height": "32px",
      "version": "1.1",
      "viewBox": "0 0 32 32",
      "width": "32px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "clip-rule": "evenodd",
      "d": "M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "arrow-clickzone"
  })]), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "gallery-content",
    attrs: {
      "id": "gallery-content"
    }
  }, _vm._l((_vm.movie.backdrops), function(backdrop, iBackdrop) {
    return _vm._c('div', {
      staticClass: "gallery-images",
      style: ({
        backgroundImage: 'url(https://image.tmdb.org/t/p/w1280' + (backdrop ? backdrop : this.movie.poster) + '), url(https://image.tmdb.org/t/p/w342' + (backdrop ? backdrop : this.movie.poster) + ')'
      })
    }, [_vm._c('a', {
      attrs: {
        "href": 'https://image.tmdb.org/t/p/original' + backdrop,
        "download": ""
      }
    }, [_vm._c('svg', {
      attrs: {
        "height": "32px",
        "version": "1.1",
        "viewBox": "0 0 32 32",
        "width": "32px",
        "xml:space": "preserve",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_vm._c('path', {
      attrs: {
        "d": "M31,22c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.448,31.552,22,31,22z"
      }
    }), _vm._c('path', {
      attrs: {
        "d": "M15.27,23.707c0.389,0.385,1.04,0.389,1.429,0l6.999-6.9c0.395-0.391,0.394-1.024,0-1.414   c-0.394-0.391-1.034-0.391-1.428,0l-5.275,5.2V1c0-0.552-0.452-1-1.01-1c-0.558,0-1.01,0.448-1.01,1v19.593l-5.275-5.2   c-0.395-0.391-1.034-0.391-1.428,0c-0.395,0.391-0.395,1.024,0,1.414L15.27,23.707z"
      }
    })])])])
  }))]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-889d540a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Movie.vue
// module id = 353
// module chunks = 2